




























































import sheetCommon from '../sheetCommon';
import { Component, Vue, Mixins, Prop, Ref } from 'vue-property-decorator';

import { Chart as ChartG2 } from '@antv/g2';
@Component({
	name: '',
	components: {},
})
export default class extends Mixins(sheetCommon) {
	@Prop({ default: () => ({}) }) public item!: any;
	@Ref() public containerRef!: HTMLElement;
	@Ref() public containerRefG2!: HTMLElement;
	private chart; // 保存chart实例
	private tableData = [];
	/**
	 * 获取指标卡
	 */
	get v() {
		const indexes = this.item.indexes || [];
		const key = (indexes[0] || {}).id;
		const data = this.item.data || [];
		return (data[0] || {})[key];
	}
	get header() {
		return [...this.item.dimensions, ...this.item.indexes];
	}
	get lenght() {
		return Math.floor(24 / this.header.length);
	}
	private mounted() {
		const { reportConfigDTO = {} } = this.item;
		if (reportConfigDTO.reportType === 'table') {
			this.tableData = this.item.data;
		} else {
			this.chart = new ChartG2({
				container: this.containerRefG2,
				autoFit: true,
			});

			this.newChart(this.item, this.chart);
		}
	}
	private destroyed() {
		this.chart ? this.chart.destroy() : (this.chart = '');
	}
}
